/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  exploreEvents: {
    id: 'explore.exploreEvents',
    defaultMessage: 'Explore {eventCount, number} {query}{eventCount, plural, one {event} other {events}} in',
  },
  filters: {
    id: 'explore.filterEvents',
    defaultMessage: 'Filter Events',
  },
  resetFilters: {
    id: 'explore.resetFilters',
    defaultMessage: 'Reset Filters',
  },
  noEvents: {
    id: 'explore.noEvents',
    defaultMessage: 'No events found in {cityName}',
  },
  noEventsDescription: {
    id: 'explore.noEventsDescription',
    defaultMessage: 'Unfortunately we can\'t match an event to your criteria. Try changing some filters to get more results.',
  },
  seeAllEvents: {
    id: 'explore.seeAllEvents',
    defaultMessage: 'See all events',
  },
})
